// @ vendors
const download = require('downloadjs');
// @ actions
const actionTypes = require('constants/actionTypes');
// @ helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { getSepaType, getSepaTypeTransfers } = require('utilities/transfersHelper');

// @ constants
const {
    BENEFICIARY_IS_NOT_RESIDENT,
    BENEFICIARY_IS_RESIDENT,
    BENEFICIARY_TYPE_EXISTING,
    DEFAULT_COUNTRY,
    NONE_SEPA,
    SEPA_INTERNATIONAL,
    SEPA_NATIONAL,
    TRANSFER_COSTS_BENEFICIARY,
    TRANSFER_COSTS_BENEFICIARY_TEXT,
    TRANSFER_COSTS_SENDER,
    TRANSFER_COSTS_SENDER_TEXT,
    TRANSFER_COSTS_SHARED,
    TRANSFER_COSTS_SHARED_TEXT
} = require('constants/index');

const emitedTransfersDetailsSuccess = (details, accountId, transferId) => ({
    type: actionTypes.SET_EMITED_TRANSFER_DETAILS_SUCCESS,
    payload: {
        accountId,
        details,
        transferId
    }
});

const emitedTransfersDetailsFailure = (error, accountId, transferId) => ({
    type: actionTypes.SET_EMITED_TRANSFER_DETAILS_FAILURE,
    payload: {
        accountId,
        error,
        transferId
    }
});

const emitedTransfersDetailsRequest = (accountId, transferId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFERS_DETAILS_REQUEST,
    payload: {
        transferId,
        accountId
    }
});

const emitedTransfersSetPdfFetching = (value) => ({
    type: actionTypes.EMITED_TRANSFER_SET_PDF_FETCHING,
    payload: {
        value
    }
});

async function buildDetailsData({immTransaction, dispatch, transfersDetailsResponse}) {
    const detailsData = { 
        ...transfersDetailsResponse
    };
    
    if(__CONTACT_CENTER__) {
        try {
            const paymentTypeRequestData = {
                query: {
                    serviceOrder: {
                        centro: {
                            empresa: immTransaction.getIn(['reference', 'enterprise']),
                            centro: immTransaction.getIn(['reference', 'center']),
                        },
                        producto: immTransaction.getIn(['reference', 'producto']),
                        numerodeorden: immTransaction.getIn(['reference', 'numerodeorden']),
                    },
                    date: transfersDetailsResponse.fechaEmision,
                    amount: immTransaction.getIn(['amount', 'amount'])
                }
            };

            const { psd2Payment } = await APIPost(dispatch, apiURLBuilder.getURL('tppGetPaymentType'), paymentTypeRequestData);
            detailsData.isPsd2Payment = psd2Payment;
        } catch (error) {
            detailsData.isPsd2Payment = true;
        }
    }
    return detailsData;
}

async function getEmitedTransferDetail(dispatch, immTransaction) {
    const sepaType = getSepaType(immTransaction.get('country'), immTransaction.getIn(['amount', 'currency']));
    let tipoSepa;

    if (immTransaction.get('transferType') === 'HH') {
        tipoSepa = NONE_SEPA;
    } else {
        tipoSepa = sepaType;
    }

    const detailsRequestData = {
        header: {
            version: '2'
        },
        query: {
            refProducto: immTransaction.getIn(['reference', 'producto']),
            refNumeroDeOrden: immTransaction.getIn(['reference', 'numerodeorden']),
            refCentro: immTransaction.getIn(['reference', 'center']),
            refEmpresa: immTransaction.getIn(['reference', 'enterprise']),
            tipoSepa: tipoSepa
        }
    };

    const accountId = immTransaction.get('accountId');
    const transferId = immTransaction.get('id');

    dispatch(emitedTransfersDetailsRequest(accountId, transferId));

    try {
        const transfersDetailsResponse = await APIGet(dispatch, apiURLBuilder.getURL('emitedTransfersDetails'), detailsRequestData);
        const transfersDetails = await buildDetailsData({ immTransaction, dispatch, transfersDetailsResponse })
        dispatch(emitedTransfersDetailsSuccess(transfersDetails, accountId, transferId));
    } catch(error) {
        if (error) {
            dispatch(emitedTransfersDetailsFailure(error.error.description, accountId, transferId))
        } else {
            throw error;
        }
    }
}

const requestEmitedTransfersDetails = immTransaction => (dispatch) => {
    return getEmitedTransferDetail(dispatch, immTransaction);
}

const getSepaNationalPdf = (dispatch, params, fileName) => {
    const {
        product,
        contractNumber,
        center,
        enterprise,
        referenceNumber,
        referenceProduct
    } = params;

    const queryParams = {
        header: {
            responseType: 'arraybuffer',
            accept: 'application/pdf'
        },
        query: {
            contratoPartenon: {
                producto: product,
                numerodecontrato: contractNumber
            },
            refTransfEmitidaSEPA: {
                centro: {
                    centro: center,
                    empresa: enterprise,
                },
                numerodeorden: referenceNumber,
                producto: referenceProduct
            }
        }
    };
    dispatch(emitedTransfersSetPdfFetching(true));
    return APIPost({
        dispatch,
        endpoint: 'emitedTransfersGetSepaNationalPdf',
        url: apiURLBuilder.getURL('emitedTransfersGetSepaNationalPdf'),
        params: queryParams
    })
        .then(response => {
            dispatch(emitedTransfersSetPdfFetching(false));
            download(response.xhr.response, fileName + '.pdf', 'application/pdf');
        })
        .catch(() => {
            dispatch(emitedTransfersSetPdfFetching(false));
        });
};

const getSepaInternationalPdf = (dispatch, params, fileName) => {
    const {
        product,
        contractNumber,
        iban,
        currency,
        center,
        enterprise,
        referenceNumber,
        referenceProduct
    } = params;

    const queryParams = {
        header: {
            responseType: 'arraybuffer',
            accept: 'application/pdf'
        },
        query: {
            contratoPartenon: {
                producto: product,
                numerodecontrato: contractNumber
            },
            ctaPago: {
                bmgnumerocuenta: iban
            },
            divisaOrdenante: currency,
            indResidenteBeneficiario: BENEFICIARY_IS_NOT_RESIDENT,
            refTransfEmitidaSEPA: {
                centro: {
                    centro: center,
                    empresa: enterprise,
                },
                numerodeorden: referenceNumber,
                producto: referenceProduct
            }
        }
    };
    dispatch(emitedTransfersSetPdfFetching(true));
    return APIPost({
        dispatch,
        endpoint: 'emitedTransfersGetSepaInternationalPdf',
        url: apiURLBuilder.getURL('emitedTransfersGetSepaInternationalPdf'),
        params: queryParams
    })
        .then(response => {
            dispatch(emitedTransfersSetPdfFetching(false));
            download(response.xhr.response, fileName + '.pdf', 'application/pdf');
        })
        .catch(() => {
            dispatch(emitedTransfersSetPdfFetching(false));
        });
};

const getNoneSepaPdf = (dispatch, params, fileName) => {
    const {
        product,
        contractNumber,
        bic,
        accountNumber,
        currency,
        costs,
        country,
        center,
        enterprise,
        referenceNumber,
        referenceProduct
    } = params;

    const queryParams = {
        header: {
            responseType: 'arraybuffer',
            accept: 'application/pdf'
        },
        query: {
            bic: bic,
            contratoPartenon: {
                producto: product,
                numerodecontrato: contractNumber
            },
            cuentaBeneficiarioTexto: accountNumber,
            divisaCtoOrd: currency,
            indGastos: {
                codigoalfanum: costs
            },
            indResidenteBeneficiario: country === DEFAULT_COUNTRY ?  // for Spain is 'S', for other countries 'N'
                BENEFICIARY_IS_RESIDENT :
                BENEFICIARY_IS_NOT_RESIDENT,
            paisBeneficiario: country,
            refTransfEmitidaNOSEPA: {
                centro: {
                    centro: center,
                    empresa: enterprise,
                },
                numerodeorden: referenceNumber,
                producto: referenceProduct
            },
            tipoCuenta: !!bic ? 'C' : 'D'
        }
    };
    dispatch(emitedTransfersSetPdfFetching(true));
    return APIPost({
        dispatch,
        endpoint: 'emitedTransfersGetNoneSepaPdf',
        url: apiURLBuilder.getURL('emitedTransfersGetNoneSepaPdf'),
        params: queryParams
    })
        .then(response => {
            dispatch(emitedTransfersSetPdfFetching(false));
            download(response.xhr.response, fileName + '.pdf', 'application/pdf');
        })
        .catch(() => {
            dispatch(emitedTransfersSetPdfFetching(false));
        });
};

const emitedTransfersGetSepaNationalPdf = (immTransaction, fileName) => (dispatch, getState) => {
    const accountId = immTransaction.get('accountId');
    const immAccount = getState().accounts.getIn(['byId', accountId]);

    const params = {
        product: immAccount.get('newProduct'),
        contractNumber: immAccount.get('newContractNumber'),
        center: immTransaction.getIn(['reference', 'center']),
        enterprise: immTransaction.getIn(['reference', 'enterprise']),
        referenceNumber: immTransaction.getIn(['reference', 'numerodeorden']),
        referenceProduct: immTransaction.getIn(['reference', 'producto'])
    };

    getSepaNationalPdf(dispatch, params, fileName);
};

const emitedTransfersGetSepaInternationalPdf = (immTransaction, fileName) => (dispatch, getState) => {
    const accountId = immTransaction.get('accountId');
    const immAccount = getState().accounts.getIn(['byId', accountId]);

    const params = {
        product: immAccount.get('newProduct'),
        contractNumber: immAccount.get('newContractNumber'),
        iban: immTransaction.getIn(['details', 'abonoIban']),
        currency: immAccount.getIn(['balance', 'currency']),
        center: immTransaction.getIn(['reference', 'center']),
        enterprise: immTransaction.getIn(['reference', 'enterprise']),
        referenceNumber: immTransaction.getIn(['reference', 'numerodeorden']),
        referenceProduct: immTransaction.getIn(['reference', 'producto'])
    };

    getSepaInternationalPdf(dispatch, params, fileName);
};

const emitedTransfersGetNoneSepaPdf = (immTransaction, fileName) => (dispatch, getState) => {
    const accountId = immTransaction.get('accountId');
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const indGastos = {
        [TRANSFER_COSTS_BENEFICIARY_TEXT]: TRANSFER_COSTS_BENEFICIARY,
        [TRANSFER_COSTS_SENDER_TEXT]: TRANSFER_COSTS_SENDER,
        [TRANSFER_COSTS_SHARED_TEXT]: TRANSFER_COSTS_SHARED // If it fails because of this, try using an 'S' instead of a 'C'
    };
    const params = {
        product: immAccount.get('newProduct'),
        contractNumber: immAccount.get('newContractNumber'),
        bic: immTransaction.getIn(['details', 'bic']),
        accountNumber: immTransaction.getIn(['details', 'accountNumber']),
        currency: immAccount.getIn(['balance', 'currency']),
        costs: indGastos[immTransaction.getIn(['details', 'transferExpenses'])],
        country: immTransaction.get('country'),
        center: immTransaction.getIn(['reference', 'center']),
        enterprise: immTransaction.getIn(['reference', 'enterprise']),
        referenceNumber: immTransaction.getIn(['reference', 'numerodeorden']),
        referenceProduct: immTransaction.getIn(['reference', 'producto'])
    };

    getNoneSepaPdf(dispatch, params, fileName);
};

const emitedTransfersGetPdf = (immTransaction, fileName) => (dispatch) => {
    const sepaType = getSepaType(immTransaction.get('country'), immTransaction.getIn(['amount', 'currency']));
    let tipoSepa;

    if (immTransaction.get('transferType') === 'HH') {
        tipoSepa = NONE_SEPA;
    } else {
        tipoSepa = sepaType;
    }

    switch (tipoSepa) {
        case SEPA_NATIONAL:
            dispatch(emitedTransfersGetSepaNationalPdf(immTransaction, fileName));
            break;
        case SEPA_INTERNATIONAL:
            dispatch(emitedTransfersGetSepaInternationalPdf(immTransaction, fileName));
            break;
        case NONE_SEPA:
            dispatch(emitedTransfersGetNoneSepaPdf(immTransaction, fileName));
            break;
    }
};

const newTransferGetSepaNationalPdf = (immTransferState, fileName) => (dispatch, getState) => {
    const immTransfer = immTransferState.getIn(['steps', 0]);
    const accountId = immTransfer.get('fromAccount');
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const reference = immTransferState.get('referenceNumber');

    const params = {
        product: immAccount.get('newProduct'),
        contractNumber: immAccount.get('newContractNumber'),
        center: reference.substring(4,8),
        enterprise: reference.substring(0,4),
        referenceNumber: reference.substring(11),
        referenceProduct: reference.substring(8,11)
    };

    getSepaNationalPdf(dispatch, params, fileName);
};

const newTransferGetSepaInternationalPdf = (immTransferState, immBeneficiary, fileName) => (dispatch, getState) => {
    const immTransfer = immTransferState.getIn(['steps', 0]);
    const accountId = immTransfer.get('fromAccount');
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const reference = immTransferState.get('referenceNumber');

    const params = {
        product: immAccount.get('newProduct'),
        contractNumber: immAccount.get('newContractNumber'),
        iban: immBeneficiary.get('iban'),
        currency: immAccount.getIn(['balance', 'currency']),
        center: reference.substring(4,8),
        enterprise: reference.substring(0,4),
        referenceNumber: reference.substring(11),
        referenceProduct: reference.substring(8,11)
    };

    getSepaInternationalPdf(dispatch, params, fileName);
};

const newTransferGetNoneSepaPdf = (immTransferState, immBeneficiary, fileName) => (dispatch, getState) => {
    const immTransfer = immTransferState.getIn(['steps', 0]);
    const accountId = immTransfer.get('fromAccount');
    const immAccount = getState().accounts.getIn(['byId', accountId]);
    const reference = immTransferState.get('referenceNumber');

    const params = {
        product: immAccount.get('newProduct'),
        contractNumber: immAccount.get('newContractNumber'),
        bic: immBeneficiary.get('bic'),
        accountNumber: immBeneficiary.get('accountNumber') || immBeneficiary.get('iban'),
        currency: immAccount.getIn(['balance', 'currency']),
        costs: immTransfer.get('costs'),
        country: immBeneficiary.get('country'),
        center: reference.substring(4,8),
        enterprise: reference.substring(0,4),
        referenceNumber: reference.substring(11),
        referenceProduct: reference.substring(8,11)
    };

    getNoneSepaPdf(dispatch, params, fileName);
};

const newTransferGetPdf = (fileName) => (dispatch, getState) => {
    const immTransferState = getState().transfer;
    const reference = immTransferState.get('referenceNumber');
    const referenceProduct = reference.substring(8,11);
    const immTransfer = immTransferState.getIn(['steps', 0]);
    const beneficiaryType = immTransfer.getIn(['beneficiary', 'type']);

    let immBeneficiary;
    if (beneficiaryType === BENEFICIARY_TYPE_EXISTING) {
        const beneficiaryId = immTransfer.getIn(['beneficiary', 'existing', 'id']);
        immBeneficiary = getState().beneficiaries.getIn(['byId', beneficiaryId]);
    } else {
        immBeneficiary = immTransfer.getIn(['beneficiary', 'new']);
    }

    const sepaType = getSepaTypeTransfers(immBeneficiary.get('country'), immBeneficiary.get('currency'), immBeneficiary.get('iban'));
    let tipoSepa;

    if (referenceProduct === '696') {
        tipoSepa = NONE_SEPA;
    } else {
        tipoSepa = sepaType;
    }

    switch (tipoSepa) {
        case SEPA_NATIONAL:
            dispatch(newTransferGetSepaNationalPdf(immTransferState, fileName));
            break;
        case SEPA_INTERNATIONAL:
            dispatch(newTransferGetSepaInternationalPdf(immTransferState, immBeneficiary, fileName));
            break;
        case NONE_SEPA:
            dispatch(newTransferGetNoneSepaPdf(immTransferState, immBeneficiary, fileName));
            break;
    }
};

module.exports = {
    emitedTransfersGetPdf,
    newTransferGetPdf,
    requestEmitedTransfersDetails
};
